import 'babel-polyfill';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { store, history} from './store';

import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import App from './components/App';
import * as utils from './util';

let arrayContainsString = (array, string) => {
  var newArr = array.filter(function(el) {
    return el.indexOf(string) >= 0;
  });
  return newArr.length > 0;
}

let prod_url = "https://realisedrate.com/";
let isRedirectionRequired = () =>{
  let origin_url = window.location.origin;
  let domains_require_redirection = [
                                      "https://www.realizedrate.com",
                                      "https://www.realisedrate.uk",
                                      "https://www.realisedrate.co.uk",
                                      "https://realizedrate.com",
                                      "https://realisedrate.uk",
                                      "https://realisedrate.co.uk",
                                      "https://nwm.realizedrate.com",
                                      "https://nwm.realisedrate.uk",
                                      "https://nwm.realisedrate.co.uk"];
  
  if(arrayContainsString(domains_require_redirection,origin_url)){
    return true;
  }
  return false;
}

if(isRedirectionRequired()){
  window.location.replace(prod_url);
}

if(!utils.isGaCookieEnabled()) {
  utils.disableGaAnalytics();
}

ReactDOM.render((
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>

), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js